import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "footer-content" }
const _hoisted_2 = { class: "footer-section" }

import { useSmoothScroll } from '@/composables/useSmoothScroll'


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterSection',
  setup(__props) {

const { scrollToId } = useSmoothScroll()

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!

  return (_openBlock(), _createBlock(_component_a_layout_footer, {
    id: "footer",
    class: "labos-footer"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_row, { gutter: [28, 28] }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: 24,
              md: 12
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createElementVNode("div", { class: "footer-section" }, [
                  _createElementVNode("h4", { class: "footer-title" }, "LabOS"),
                  _createElementVNode("p", { class: "footer-text" }, " AI-XR co-scientist for modern labs — from reasoning to real-world execution and documentation. ")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              xs: 12,
              md: 6
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "footer-title" }, "Quick Links", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "footer-link",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(scrollToId)('about')))
                  }, "About"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "footer-link",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(scrollToId)('use')))
                  }, "Use LabOS Now"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "footer-link",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(scrollToId)('media')))
                  }, "Media"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "footer-link",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(scrollToId)('benchmark')))
                  }, "Benchmark"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "footer-link",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(scrollToId)('leaderboard')))
                  }, "Leaderboard"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "footer-link",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(scrollToId)('team')))
                  }, "Team")
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              xs: 12,
              md: 6
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createElementVNode("div", { class: "footer-section" }, [
                  _createElementVNode("h4", { class: "footer-title" }, "Contact"),
                  _createElementVNode("a", {
                    href: "mailto:congle@stanford.edu",
                    class: "footer-link"
                  }, "congle@stanford.edu"),
                  _createElementVNode("a", {
                    href: "mailto:mengdiw@princeton.edu",
                    class: "footer-link"
                  }, "mengdiw@princeton.edu")
                ], -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "footer-copyright" }, " © 2025 LabOS Project. All rights reserved. ", -1))
      ])
    ]),
    _: 1
  }))
}
}

})